var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXCloseMobileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000000d9",
    fillRule: "evenodd",
    d: "M9.427 8l6.468-6.468a.356.356 0 0 0 0-.505l-.921-.923A.355.355 0 0 0 14.72 0a.354.354 0 0 0-.253.104L8 6.574 1.532.103a.367.367 0 0 0-.505 0l-.922.923a.356.356 0 0 0 0 .505L6.573 8 .105 14.468a.356.356 0 0 0 0 .505l.922.924a.363.363 0 0 0 .505 0L8 9.427l6.468 6.47a.361.361 0 0 0 .506 0l.922-.924a.358.358 0 0 0 0-.505L9.427 8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXCloseMobileIcon);
export default __webpack_public_path__ + "static/media/x-close-mobile-icon.1ffcb5bd0170d364cb8540f17e36ad4b.svg";
export { ForwardRef as ReactComponent };